export default __webpack_public_path__ + "static/media/dang_giao.5175c600.svg";